import React, { Component } from 'react'
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import history from '../../routes/history'
import * as actionCreator from '../../redux/actions/data-action';
import { TaskSegment, getTaskTypeIdById } from '../../redux/actions/data-action';
import { Box } from '../../third-party-components/material-ui';
import NextButton from './../../assets/images/next@2x.png';

import { AssessmentContainer, AssessmentBody,
            AssessmentContent, AssessmentNavigationPrevious, AssessmentNavigationNext, AssessmentFooter,
            AssessmentContentHeader, AssessmentContentSection,AssessmentContentAction, AssessmentContentActionButton
} from './common';

const toPrevious = "/Demographic/Rater";

class AssessmentInstructionFrenchTeacher extends Component {
  componentDidMount()
  {
    window.history.pushState(null, null, history.location.href);
      window.onpopstate = function(event) {
          history.go(1);
      };
  }

    getFirstTaskTypeLink() {
        const { taskTypes } = this.props;
        const taskType = getTaskTypeIdById(taskTypes[0].id);

        var hasPractice = taskTypes[0].practice.length > 0

        return hasPractice ? `/Assessment/Tasks/${taskType.type}/${TaskSegment.INSTRUCTION}` : `/Assessment/Tasks/${taskType.type}/${TaskSegment.TASK}/1`;
    }

    handlePrevious() {
        history.push(toPrevious);
    }

    handleNext(nextLink) {
        history.push(nextLink);
    }

    render() {
      const version = parseInt(sessionStorage.getItem('temp-version-id'));

        return (
            <AssessmentContainer>
                <AssessmentContentHeader>Instructions</AssessmentContentHeader>
                <AssessmentBody>
                    <AssessmentContent className="assessment-content-introduction">
                        <AssessmentContentSection style={{textAlign: 'left'}}>
                            Remarque: assurez-vous que la fenêtre s'affiche en plein écran durant toute la durée du test.
                            <br/>
                            <br/>
                            Voici des choses que des enseignants/es peuvent dire de leurs élèves. Veuillez lire attentivement chaque affirmation. Indiquez à quel point ces affirmations sont vraies pour cet/te élève ou à quelle fréquence cela est arrivé au cours du <b>dernier mois</b>. Réfléchissez si:
                            <br/>
                            <br/>
                            <li>Au cours du dernier mois, ça n’a <b><i>pas été vrai du tout</i></b> dans le cas de mon élève. Cela n’est <b><i>jamais</i></b> arrivé <b><i>(ou rarement)</i></b>.</li>
                            <li>Au cours du dernier mois, ça a été <b><i>un peu vrai</i></b> dans le cas de mon élève. C’est arrivé <b><i>à l’occasion</i></b>.</li>
                            <li>Au cours du dernier mois, ça a été <b><i>plutôt vrai</i></b> dans le cas de mon élève. C’est arrivé <b><i>souvent/beaucoup</i></b>.</li>
                            <li>Au cours du dernier mois, ça a été <b><i>tout à fait vrai</i></b> dans le cas de mon élève. C’est arrivé <b><i>très souvent/tout le temps</i></b>.</li>
                            <br/>
                            <br/>
                            Choisissez seulement une réponse pour chaque item. C'est important de répondre à tous les items. Donnez la meilleure réponse possible pour les items que vous jugez difficiles.
                            <br/>
                            <br/>
                            <Box>Quand vous êtes prêt à commencer, cliquez sur la flèche {'>'} pour avancer.</Box>
                        </AssessmentContentSection>
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentContentAction>
                        <AssessmentContentActionButton styleType='arrows' onClick={this.handlePrevious}>{'<'}</AssessmentContentActionButton>
                        <AssessmentContentActionButton styleType='arrows' onClick={() => this.handleNext(this.getFirstTaskTypeLink())}>{'>'}</AssessmentContentActionButton>
                    </AssessmentContentAction>
                <AssessmentFooter includeLogo={true}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

const mapStateToProps = (state, ownState) => (
    
    {
    taskTypes : state.data.tasks
})

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentInstructionFrenchTeacher));